<template>
  <transition name="fade">
    <div class="confirm-dialog" v-if="openModal">
      <div class="wrapper">
        <div class="close">
          <svg @click="close" width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.41425 5.35328L9.70725 2.06028C10.0982 1.66928 10.0982 1.03728 9.70725 0.646277C9.31625 0.255277 8.68425 0.255277 8.29325 0.646277L5.00025 3.93928L1.70725 0.646277C1.31625 0.255277 0.68425 0.255277 0.29325 0.646277C-0.09775 1.03728 -0.09775 1.66928 0.29325 2.06028L3.58625 5.35328L0.29325 8.64628C-0.09775 9.03728 -0.09775 9.66928 0.29325 10.0603C0.48825 10.2553 0.74425 10.3533 1.00025 10.3533C1.25625 10.3533 1.51225 10.2553 1.70725 10.0603L5.00025 6.76728L8.29325 10.0603C8.48825 10.2553 8.74425 10.3533 9.00025 10.3533C9.25625 10.3533 9.51225 10.2553 9.70725 10.0603C10.0982 9.66928 10.0982 9.03728 9.70725 8.64628L6.41425 5.35328Z" fill="#3C3C3C"/>
          </svg>
        </div>
        <h3>Witaj na stronie naszego sklepu</h3>
        <p>Lubisz mieć wszystko pod kontrolą, według Twoich oczekiwań? <br>
          My także. Skonfiguruj ten produkt tak jak chcesz.</p>

        <div class="buttons">
          <button type="button" class="create" @click="confirm">
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10.5 14C11.8063 14 12.9175 14.8349 13.3293 16.0001L19.5 16C20.0523 16 20.5 16.4477 20.5 17C20.5 17.5523 20.0523 18 19.5 18L13.329 18.0009C12.9169 19.1656 11.8059 20 10.5 20C9.19412 20 8.08312 19.1656 7.67102 18.0009L1.5 18C0.947715 18 0.5 17.5523 0.5 17C0.5 16.4477 0.947715 16 1.5 16L7.67067 16.0001C8.08249 14.8349 9.19375 14 10.5 14ZM10.5 16C9.94771 16 9.5 16.4477 9.5 17C9.5 17.5523 9.94771 18 10.5 18C11.0523 18 11.5 17.5523 11.5 17C11.5 16.4477 11.0523 16 10.5 16ZM17.5 7C19.1569 7 20.5 8.34315 20.5 10C20.5 11.6569 19.1569 13 17.5 13C16.1941 13 15.0831 12.1656 14.671 11.0009L1.5 11C0.947715 11 0.5 10.5523 0.5 10C0.5 9.44771 0.947715 9 1.5 9L14.6707 9.00009C15.0825 7.83485 16.1937 7 17.5 7ZM17.5 9C16.9477 9 16.5 9.44771 16.5 10C16.5 10.5523 16.9477 11 17.5 11C18.0523 11 18.5 10.5523 18.5 10C18.5 9.44771 18.0523 9 17.5 9ZM3.5 0C4.8118 0 5.92695 0.841956 6.33453 2.01495C6.38799 2.00469 6.44344 2 6.5 2L19.5 2C20.0523 2 20.5 2.44772 20.5 3C20.5 3.55228 20.0523 4 19.5 4L6.5 4C6.44344 4 6.38799 3.99531 6.33399 3.98628C5.92695 5.15804 4.8118 6 3.5 6C1.84315 6 0.5 4.65685 0.5 3C0.5 1.34315 1.84315 0 3.5 0ZM3.5 2C2.94772 2 2.5 2.44772 2.5 3C2.5 3.55228 2.94772 4 3.5 4C4.05228 4 4.5 3.55228 4.5 3C4.5 2.44772 4.05228 2 3.5 2Z"
                    fill="white"/>
            </svg> Skonfiguruj ten model
          </button>
          <p>Lub</p>
          <button type="button" class="cancel" @click="cancel">Przejdź na stronę produktu</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "DefaultDialog",
  computed: {
    ...mapGetters('customizer', ['getConfirmationDialogOpen'])
  },
  watch: {
    openModal(n) {
      if (n) {
        document.getElementsByTagName('html')[0].style.overflow = "hidden";
      } else {
        document.getElementsByTagName('html')[0].style.removeProperty('overflow')
      }
    }
  },
  data () {
    return {
      openModal: false
    }
  },
  mounted() {
    if ((window.location.search.includes('clid') || (document.referrer && !document.referrer.includes('ramaro.pl'))) && window.location.search.includes('attribute_pa')) {
      this.openModal = true
    }
  },
  methods: {
    ...mapActions('customizer', ['resetCustomizer', 'initResetCustomizer']),
    confirm() {
      this.$parent.setCustomizerOpen(true)
      this.openModal = false
    },
    close () {
      this.openModal = false
      const url = document.querySelector('#customizer-container').dataset.productUrl
      window.history.replaceState({ product: 'Updated' }, document.title, url)
      this.initResetCustomizer()
    },
    cancel() {
      this.openModal = false
      const url = document.querySelector('#customizer-container').dataset.productUrl
      window.history.replaceState({ product: 'Updated' }, document.title, url)
      // this.initResetCustomizer()
      // window.location.href = document.getElementById('customizer-container').dataset('product-url')
    },
  }
}
</script>

<style scoped lang="scss">
.confirm-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, .5);
  z-index: 9999;

  display: flex;
  justify-content: center;
  align-items: center;

  .wrapper {
    font-family: "neue-haas-grotesk-display", sans-serif;
    padding: 50px 25px;
    background: #fff;
    box-shadow: 0 10px 12px rgba(26, 26, 26, 0.1);
    border-radius: 4px;
    max-width: 450px;
    position: relative;

    @media (max-width: 480px) {
      margin: 0 20px;
      padding: 20px;
    }

    .close {
      position: absolute;
      top: 25px;
      right: 25px;
      cursor: pointer;

      @media (max-width: 480px) {
        position: relative;
        text-align: right;
        margin: 0 0 15px 0;
        top: 0;
        right: 0;
      }
    }

    h3 {
      font-size: 22px;
      margin: 0 0 15px 0;
      color: #3C3C3C;
    }

    p {
      line-height: 22px;
      font-size: 14px;
      color: #3C3C3C;
    }

    .buttons {
      text-align: center;
      margin: 50px 0 0 0;
      display: flex;
      flex-direction: column;

      @media (max-width: 480px) {
        display: flex;
        justify-content: space-between;
      }

      p {
        color: #C8C8C8;
        margin: 13px 0;
      }

      button {
        padding: 15px 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        transition: all .2s;
        cursor: pointer;
        border: 0;

        &.create {
          background: #74C7ED;
          color: #fff;
          svg {
            width: 18px;
            height: auto;
            transition: all .2s;
            margin-right: 10px;

            path {
              fill: #fff;
            }
          }
          &:hover {
            background: #4EA9D3;
          }
          &:disabled {
            background: #EFEFEF;
            color: #C8C8C8;

            svg path {
              fill: #C8C8C8;
            }
          }
        }

        &.cancel {
          border: 2px solid #252525;
          color: #252525;
          background: #fff;
          margin: 0;

          &:hover {
            background: #f1f1f1;
          }
        }
      }


    }
  }
}
</style>
